import _ from "lodash";

export const isSubset = (superSet, subSet) => {
  return subSet.length === _.intersection(subSet, superSet).length;
};
